<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditContacts()"
	(editClicked)="openEdit()"
	[disableEditButton]="isEditDisabled() || isFrozen()"
	[disableEditTranslationKey]="editDisabledReason()"
	[disableEditTranslationParams]="disableEditTranslationParams()"
>
	{{ 'network_contact.details.title' | transloco: { date: contact()?.contactedAt | date: dateDisplayFormat } }}
</lvr-heading>

<section class="grid" role="region">
	<table>
		<!-- Took place on / Contact type -->
		<tr>
			<th scope="col">{{ 'contact.details.took_place_on' | transloco }}</th>
			<th scope="col">{{ 'contact.details.contact_type' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ contact()?.contactedAt | date: dateDisplayFormat }}</td>
			<td>{{ contact()?.contactType?.remark }}</td>
		</tr>

		<!-- Keyword / Confidential -->
		<tr>
			<th scope="col">{{ 'contact.details.keyword' | transloco }}</th>
			<th scope="col">{{ 'contact.details.confidential' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ contact()?.keyword }}</td>
			<td>
				{{ contact()?.confidential ? ('contact.details.true' | transloco) : ('contact.details.false' | transloco) }}
			</td>
		</tr>

		<!-- Participants / Documents -->
		<tr>
			<th scope="col">{{ 'contact.details.participants' | transloco }}</th>
			<th scope="col">{{ 'contact.details.documents' | transloco }}</th>
		</tr>
		<tr>
			<td>
				<ul>
					@for (participant of contact()?.participants; track trackItem(participant)) {
						<li class="participant">
							<div>
								<p>{{ participant.item.firstName + ' ' + participant.item.name }}</p>
								<span class="relation">{{ mapPersonTypeToKey(participant.personTypeId) | transloco }}</span>
							</div>
							@if (isContactTypeAnEmail(contact())) {
								<lvr-send-email-button
									[participantName]="participant.item.firstName + ' ' + participant.item.name"
									[subject]="contact()?.keyword ?? ''"
									[body]="contact()?.remark ?? ''"
									[contactPoints]="participant.contactPoints"
								></lvr-send-email-button>
							}
						</li>
					}
				</ul>
			</td>
			<td>
				<ul>
					@for (doc of contact()?.documents; track doc.id) {
						<li>
							<lvr-document-item [document]="buildDocumentEntryFromContact(doc)!" (open)="onFileClick(doc)">
							</lvr-document-item>
						</li>
					}
				</ul>
			</td>
		</tr>

		<!-- Remark -->
		<tr>
			<th scope="col" colspan="2">{{ 'contact.details.remark' | transloco }}</th>
		</tr>
		<tr>
			<td colspan="2">{{ contact()?.remark }}</td>
		</tr>
	</table>
</section>
